import React, { type ReactNode, createContext, useMemo } from "react";

import { FormalizrTranslationLabels } from "@types";

type ContentfulFormalizrProviderState = {
    formName: string;
    locale: string;
    translations: FormalizrTranslationLabels;
    blacklistDomains?: string[];
    isSubmitting?: boolean;
};

const ContentfulFormalizrContext =
    createContext<ContentfulFormalizrProviderState | null>(null);

type ContentfulFormalizrProviderProps = ContentfulFormalizrProviderState & {
    children: ReactNode;
};

const ContentfulFormalizrProvider = ({
    children,
    formName,
    locale,
    translations,
    blacklistDomains,
    isSubmitting,
}: ContentfulFormalizrProviderProps) => {
    const value = useMemo(
        () => ({
            formName,
            locale,
            translations,
            blacklistDomains,
            isSubmitting,
        }),
        [formName, locale, translations, blacklistDomains, isSubmitting],
    );

    return (
        <ContentfulFormalizrContext.Provider value={value}>
            {children}
        </ContentfulFormalizrContext.Provider>
    );
};

export {
    ContentfulFormalizrContext,
    ContentfulFormalizrProvider,
    type ContentfulFormalizrProviderState,
};
